import React from "react";
import { Grid, FormControl, InputLabel, Select, MenuItem, TextField, FormControlLabel, Switch, Typography } from "@material-ui/core";

/**
 * «Historial al vincular» (doc 0439 S6.1). Solo 7, 15 o 30 días: no existe «todo el historial»,
 * porque traerlo todo tumba el servidor. Por defecto, no se trae nada.
 */
export const HISTORY_OPTIONS = [
  { value: "off", label: "No traer historial (recomendado)" },
  { value: "7", label: "Últimos 7 días" },
  { value: "15", label: "Últimos 15 días" },
  { value: "30", label: "Últimos 30 días" },
];

export const policyToOption = (p) => (p?.historyMode === "recent" ? String(p.historyDays) : "off");

export const optionToPolicy = (option, p) => ({
  historyMode: option === "off" ? "off" : "recent",
  historyDays: option === "off" ? Number(p?.historyDays || 7) : Number(option),
  historyMaxPerChat: Number(p?.historyMaxPerChat || 200),
  historyIncludeGroups: Boolean(p?.historyIncludeGroups),
});

const HistoryPolicySection = ({ policy, onChange, disabled, menuProps }) => {
  const option = policyToOption(policy);
  const activo = option !== "off";

  return (
    <>
      <Grid item xs={12} sm={activo ? 6 : 12}>
        <FormControl variant="outlined" size="small" fullWidth disabled={disabled}>
          <InputLabel id="history-mode-label">Historial al vincular</InputLabel>
          <Select
            labelId="history-mode-label"
            label="Historial al vincular"
            MenuProps={menuProps}
            value={option}
            onChange={(e) => onChange(optionToPolicy(e.target.value, policy))}
          >
            {HISTORY_OPTIONS.map((o) => (
              <MenuItem key={o.value} value={o.value}>
                {o.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      {activo && (
        <>
          <Grid item xs={6} sm={3}>
            <TextField
              label="Máx. por chat"
              type="number"
              variant="outlined"
              size="small"
              fullWidth
              disabled={disabled}
              inputProps={{ min: 1, max: 1000 }}
              value={policy?.historyMaxPerChat ?? 200}
              onChange={(e) => onChange({ ...policy, historyMaxPerChat: Number(e.target.value) })}
            />
          </Grid>
          <Grid item xs={6} sm={3} style={{ display: "flex", alignItems: "center" }}>
            <FormControlLabel
              control={
                <Switch
                  size="small"
                  color="primary"
                  disabled={disabled}
                  checked={Boolean(policy?.historyIncludeGroups)}
                  onChange={(e) => onChange({ ...policy, historyIncludeGroups: e.target.checked })}
                />
              }
              label="Incluir grupos"
            />
          </Grid>
        </>
      )}
      <Grid item xs={12} style={{ paddingTop: 0 }}>
        <Typography variant="caption" color="textSecondary">
          {activo
            ? "Se aplica al vincular por QR. Traer historial consume memoria y disco; cada mensaje e imagen se descarga una sola vez."
            : "Al vincular no se descargan mensajes antiguos: la conexión arranca ligera. Se puede activar más adelante (se aplica en la siguiente vinculación)."}
        </Typography>
      </Grid>
    </>
  );
};

export default HistoryPolicySection;
